import { createTypes, async } from 'redux-action-creator'

const actionTypes = createTypes([
  'SET_DATA',
  ...async('CANCEL_SUBSCRIPTION'),
], 'USER')

export { actionTypes }
